var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-sources" },
    [
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true },
          })
        : _vm._e(),
      _c(
        "vs-row",
        { staticClass: "sources-main" },
        [
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              _c("div", { staticClass: "table-title" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.title")))]),
              ]),
              _c("p", { staticClass: "subtitle" }, [
                _vm._v(_vm._s(_vm.$t("dash.sources.subtitle"))),
              ]),
              _vm.checkLock("sources") || _vm.checkLock("partner")
                ? _c(
                    "Tooltip",
                    { attrs: { text: _vm.$t("dash.locked"), position: "top" } },
                    [
                      _c(
                        "vs-button",
                        {
                          staticClass: "btn-img btn-large",
                          attrs: {
                            color: "#2F1937",
                            size: "large",
                            "vs-type": "filled",
                            disabled: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addNewSource()
                            },
                          },
                        },
                        [
                          _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.add")))]),
                          _c("img", {
                            staticClass: "icon-white",
                            attrs: {
                              src: require("../../../assets/img/tabs/ico-sources.svg"),
                              alt: "rss",
                            },
                          }),
                        ]
                      ),
                      _c("span", [_vm._v(" ")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkLock("sources") || _vm.checkLock("partner")
                ? _c(
                    "vs-button",
                    {
                      staticClass: "btn-large btn-img",
                      attrs: { color: "#2F1937", "vs-type": "filled" },
                      on: {
                        click: function ($event) {
                          return _vm.goToSettings()
                        },
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("dash.button.changeplan"))),
                      ]),
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/img/icon_unlock.svg"),
                          alt: "unlock",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              !_vm.checkLock("sources") && !_vm.checkLock("partner")
                ? _c(
                    "vs-button",
                    {
                      staticClass: "btn-img btn-large",
                      attrs: {
                        color: "#2F1937",
                        size: "large",
                        "vs-type": "filled",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addNewSource()
                        },
                      },
                    },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("dash.sources.add")))]),
                      _c("img", {
                        staticClass: "icon-white",
                        attrs: {
                          src: require("../../../assets/img/tabs/ico-sources.svg"),
                          alt: "rss",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "search-page" },
                [
                  _c("vs-input", {
                    staticClass: "inputx",
                    class: { input: true },
                    attrs: {
                      color: "#B20564",
                      "icon-after": "true",
                      icon: "search",
                      placeholder: _vm.$t(
                        "dash.settings.user.label.source_filter"
                      ),
                    },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.sourceFilter,
                      callback: function ($$v) {
                        _vm.sourceFilter = $$v
                      },
                      expression: "sourceFilter",
                    },
                  }),
                ],
                1
              ),
              !!_vm.sourceList.length
                ? _c("div", { staticClass: "sources-tables" }, [
                    _c(
                      "div",
                      { staticClass: "sources-wrapper" },
                      [
                        _c("component-table", {
                          attrs: {
                            gridData: _vm.sourceListReverse,
                            columns: _vm.customColumns,
                            name: "custom-sources",
                          },
                          on: {
                            edit: _vm.edit,
                            openUpdateBots: _vm.openUpdateBots,
                            goToBot: _vm.goToBot,
                            remove: _vm.removeSource,
                            addToBot: _vm.addToBot,
                            confirmEnable: _vm.confirmEnable,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay sources-overlay",
          attrs: { title: "Source", active: _vm.add },
          on: {
            "update:active": function ($event) {
              _vm.add = $event
            },
          },
        },
        [
          _c("component-sources-overlay", {
            attrs: { mode: _vm.mode, editSource: _vm.editSource.id },
            on: {
              "close-source-form": _vm.cleanData,
              fetchSources: _vm.fetchSources,
            },
          }),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay groups source-to-pages",
          attrs: {
            title: _vm.$t("dash.source.affected-to-pages", {
              name: _vm.sourceSelected ? _vm.sourceSelected.name : "",
            }),
            active: _vm.popupSourceToPages,
          },
          on: {
            "update:active": function ($event) {
              _vm.popupSourceToPages = $event
            },
          },
        },
        [
          _vm.popupSourceToPages
            ? _c("component-pages-selector", {
                attrs: {
                  noName: true,
                  groups: _vm.groups,
                  pagesAdded: _vm.pagesAdded,
                  type: "source_to_page",
                },
                on: { submit: _vm.updateBots },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: _vm.dialog.title, active: _vm.dialog.show },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            },
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.dialog.message))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }